module.exports = __webpack_public_path__ + "img/dasilva.b423e9c8.png";